// extracted by mini-css-extract-plugin
export default {"allocation":"ebVDn30slge50jHBiYMf"};